var lat = $('#map').data('lat');
var lng = $('#map').data('lng');

$(document).ready(function() {
    $('form .file-prevent-overflow .file-uploader-wrapper .upload-file').on('click', function() {
       $(this).closest('.file-prevent-overflow').find('input[type="file"]').click();
       return false;
    });

    $('form .file-prevent-overflow input[type="file"]').on('change', function() {
        var filename = this.files[0].name;
        var size = (this.files[0].size / 1000000).toFixed(2);
        $(this).closest('.file-prevent-overflow').find('.file-uploader-wrapper .filename').text(filename + ' (' + size+'Mo)');
        $(this).closest('.file-prevent-overflow').find('.file-uploader-wrapper .delete').show();
    });

    $('form .file-prevent-overflow .file-uploader-wrapper .delete').on('click', function() {
        $(this).closest('.file-uploader-wrapper').find('.filename').text('');
        $(this).closest('.file-prevent-overflow').find('input[type="file"]').val('');
        $(this).hide();
        return false;
    });
});

function initMap() {
    var myLatLng = {lat: lat, lng: lng};

    map = new google.maps.Map(document.getElementById('map'), {
        center: myLatLng,
        zoom: 17
    });

    var options = {
        zoomControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        scrollwheel: false,
        gestureHandling: 'greedy',
        styles: [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#87eaae"
                    }
                ]
            }
        ]
    };

    map.setOptions(options);

    setMarker();
}

function setMarker() {
    var bounds = new google.maps.LatLngBounds();


    if (lat && lng) {
        var position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
        bounds.extend(position);

        marker = new google.maps.Marker({
            map: map,
            position: position,
            title: ''
        });

        marker.setIcon(({
            url: '../wp-content/themes/tiz-europortes/assets/img/layout/picto-map-marker.png'
        }));
    }
}